<template>
  <div class="support">
    <!-- 导航栏 -->
    <Navbar :entName="entName" :logo="logo" />

    <!-- 页面内容 -->
    <section class="support-content">
      <div class="container">
        <h2>服务支持</h2>

        <!-- 我们的服务 -->
        <section class="services-section">
          <h3>我们的服务</h3>
          <div class="services-grid">
            <div class="service-card">
              <div class="service-image">
                <img
                  src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=ERP%20implementation%20service&image_size=square"
                  alt="ERP系统实施"
                />
              </div>
              <h4>ERP系统实施</h4>
              <p>
                为大型企业提供定制化的ERP系统实施服务，包括需求分析、系统设计、开发、测试和上线。
              </p>
            </div>
            <div class="service-card">
              <div class="service-image">
                <img
                  src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=smart%20factory%20consulting&image_size=square"
                  alt="智能工厂咨询"
                />
              </div>
              <h4>智能工厂咨询</h4>
              <p>
                提供智能工厂规划、设计和实施咨询服务，帮助企业实现生产自动化和智能化。
              </p>
            </div>
            <div class="service-card">
              <div class="service-image">
                <img
                  src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=digital%20supply%20chain%20optimization&image_size=square"
                  alt="数字供应链优化"
                />
              </div>
              <h4>数字供应链优化</h4>
              <p>通过数字化技术优化供应链管理，提高供应链效率和透明度。</p>
            </div>
            <div class="service-card">
              <div class="service-image">
                <img
                  src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=CPQ%20system%20integration&image_size=square"
                  alt="CPQ系统集成"
                />
              </div>
              <h4>CPQ系统集成</h4>
              <p>为企业提供CPQ系统集成服务，实现快速报价和配置管理。</p>
            </div>
            <div class="service-card">
              <div class="service-image">
                <img
                  src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=IT%20consulting%20services&image_size=square"
                  alt="IT咨询服务"
                />
              </div>
              <h4>IT咨询服务</h4>
              <p>提供IT战略规划、技术评估和解决方案设计等咨询服务。</p>
            </div>
            <div class="service-card">
              <div class="service-image">
                <img
                  src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=system%20maintenance%20support&image_size=square"
                  alt="系统维护支持"
                />
              </div>
              <h4>系统维护支持</h4>
              <p>为企业提供系统维护、升级和技术支持服务，确保系统稳定运行。</p>
            </div>
          </div>
        </section>

        <!-- 常见问题 -->
        <div class="faq-section">
          <h3>常见问题</h3>
          <div class="faq-list">
            <div class="faq-item">
              <div class="faq-question">
                <h4>如何选择适合企业的数字化解决方案？</h4>
              </div>
              <div class="faq-answer">
                <p>
                  我们会根据企业的规模、行业特点、业务需求等因素，为企业定制个性化的数字化解决方案，确保方案能够满足企业的实际需求。
                </p>
              </div>
            </div>
            <div class="faq-item">
              <div class="faq-question">
                <h4>系统实施周期需要多长时间？</h4>
              </div>
              <div class="faq-answer">
                <p>
                  系统实施周期取决于项目的规模和复杂度，一般来说，小型项目需要1-3个月，中型项目需要3-6个月，大型项目需要6-12个月。
                </p>
              </div>
            </div>
            <div class="faq-item">
              <div class="faq-question">
                <h4>系统上线后如何确保稳定运行？</h4>
              </div>
              <div class="faq-answer">
                <p>
                  我们会提供系统监控服务，及时发现和解决系统运行中的问题。同时，我们还会定期进行系统维护和优化，确保系统稳定运行。
                </p>
              </div>
            </div>
            <div class="faq-item">
              <div class="faq-question">
                <h4>如何获取技术支持？</h4>
              </div>
              <div class="faq-answer">
                <p>
                  您可以通过电话、邮件、在线客服等方式获取技术支持，我们的技术支持团队会在第一时间响应您的问题。
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- 联系我们 -->
        <div class="contact-section">
          <h3>联系我们</h3>
          <div class="contact-info">
            <div class="contact-item">
              <h4>技术支持热线</h4>
              <p>400-123-4567</p>
            </div>
            <div class="contact-item">
              <h4>邮箱</h4>
              <p>support@wisdomdeliver.com</p>
            </div>
            <div class="contact-item">
              <h4>工作时间</h4>
              <p>周一至周五 9:00-18:00</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <Footer v-bind="footerData" />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import { pageDataMixin } from "@/mixins/pageData";

export default {
  name: "Support",
  components: {
    Navbar,
    Footer,
  },
  mixins: [pageDataMixin],
};
</script>

<style scoped>
.support {
  font-family: Arial, sans-serif;
}

/* 通用样式 */
.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

/* 服务支持 */
.support-content {
  padding: 4rem 0;
}

.support-content h2 {
  font-size: 2rem;
  text-align: center;
  margin-bottom: 3rem;
}

/* 我们的服务 */
.services-section {
  margin-bottom: 4rem;
}

.services-section .container {
  flex-direction: column;
  align-items: center;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
  width: 100%;
}

.service-card {
  background-color: #f9f9f9;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-image {
  margin-bottom: 1rem;
}

.service-image img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
}

.service-card h4 {
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

/* 常见问题 */
.faq-section {
  margin-bottom: 4rem;
}

.faq-section h3 {
  font-size: 1.5rem;
  margin-bottom: 2rem;
  text-align: center;
}

.faq-list {
  background-color: #f9f9f9;
  border-radius: 8px;
  overflow: hidden;
}

.faq-item {
  border-bottom: 1px solid #eee;
}

.faq-item:last-child {
  border-bottom: none;
}

.faq-question {
  padding: 1.5rem;
  background-color: white;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.faq-question:hover {
  background-color: #f0f0f0;
}

.faq-question h4 {
  margin: 0;
  font-size: 1.1rem;
}

.faq-answer {
  padding: 1.5rem;
  background-color: #f9f9f9;
  border-top: 1px solid #eee;
}

.faq-answer p {
  margin: 0;
  line-height: 1.6;
}

/* 联系我们 */
.contact-section h3 {
  font-size: 1.5rem;
  margin-bottom: 2rem;
  text-align: center;
}

.contact-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  text-align: center;
}

.contact-item h4 {
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}

.contact-item p {
  margin: 0;
  color: #666;
}

/* 通用样式 */
.text-center {
  text-align: center;
  margin-top: 2rem;
  width: 100%;
}

.btn {
  display: inline-block;
  background-color: #007bff;
  color: white;
  padding: 0.8rem 1.5rem;
  text-decoration: none;
  border-radius: 50px;
  transition: background-color 0.3s ease;
}

.btn:hover {
  background-color: #0069d9;
}

h3 {
  font-size: 1.8rem;
  text-align: center;
  margin-bottom: 2rem;
  width: 100%;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
  }

  .contact-info {
    grid-template-columns: 1fr;
  }
}
</style>
